<template>
    <v-dialog
        v-model="$store.state.dispatch.lastETA"
        max-width="700px"
    >
    <v-card>
        <v-toolbar color="primary" dense dark>
            Last Eta List
            <v-spacer></v-spacer>
            <button @click="$store.state.dispatch.lastETA = false;" icon >
                <v-icon>mdi-close</v-icon>
            </button>
        </v-toolbar>
        <v-container grid-list-xs fluid>
            <v-data-table 
            hide-default-footer 
            :headers="headers"
            :items="items"> </v-data-table>
        </v-container>
    </v-card>
    </v-dialog>
</template>
<script>
import axios from "axios";
export default {
    props:['Truck'],
    data: function() {
        return {
            items: [],
            headers: [
                { text: 'Truck', value: 'Truck', width: '10%' },
                { text: 'ShiftDetail', value: 'ShiftDetail', width: '' },
                { text: 'Date', value: 'MaxOfDate', width: '' },
                { text: 'Shift', value: 'MaxOfShift', width: '' },
                { text: 'StationEnd', value: 'MaxOfStEnd', width: '' },
                { text: 'ETA Time', value: 'MaxOfETATime', width: '' }
            ]
        };
    },
    mounted() {
        console.log(this.Truck);
        this.getLastEta(this.Truck);
    },
    methods: {
        getLastEta: function(Truck) {
            axios
                .get('shift-detail/last/eta/' + Truck, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.items = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
